// extracted by mini-css-extract-plugin
export default {"copyRightBg":"copyright_copyRightBg__DItKA"};